import { useMemo } from 'react';
import { useRealplayStore } from 'features/realplays/RealPlays.store';

const RealPlayRecordDataHelper = () => {
  //values
  const { realPlayRecording, isLoadingVideoTemp } = useRealplayStore();

  const assignment_uuid = useMemo(
    () => realPlayRecording?.assignment_uuid,
    [realPlayRecording?.assignment_uuid]
  );

  const self_assigned = useMemo(
    () => realPlayRecording?.self_assigned,
    [realPlayRecording?.self_assigned]
  );

  const assigned_by_user = useMemo(
    () => realPlayRecording?.assigned_by_user,
    [realPlayRecording?.assigned_by_user]
  );

  const assigned_to_user = useMemo(
    () => realPlayRecording?.assigned_to_user,
    [realPlayRecording?.assigned_to_user]
  );
  const roleplay = useMemo(() => realPlayRecording?.roleplay, [realPlayRecording?.roleplay]);
  const scenarios = useMemo(() => realPlayRecording?.scenarios, [realPlayRecording?.scenarios]);
  const ratingCriteria = useMemo(
    () => realPlayRecording?.rating_criteria,
    [realPlayRecording?.rating_criteria]
  );
  const client = useMemo(() => realPlayRecording?.ai_persona, [realPlayRecording?.ai_persona]);
  const attitude = useMemo(() => realPlayRecording?.attitude, [realPlayRecording?.attitude]);
  const voice_id = useMemo(() => realPlayRecording?.voice_id, [realPlayRecording?.voice_id]);
  const customer_context = useMemo(
    () => realPlayRecording?.customer_context,
    [realPlayRecording?.customer_context]
  );
  const selectedScenario = useMemo(
    () => realPlayRecording?.scenarioSelected,
    [realPlayRecording?.scenarioSelected]
  );
  const sessionInfoTemp = useMemo(
    () => realPlayRecording?.sessionInfoTemp,
    [realPlayRecording?.sessionInfoTemp]
  );
  const endDate = useMemo(() => realPlayRecording?.end_date, [realPlayRecording?.end_date]);
  const session_uuid = useMemo(() => sessionInfoTemp?.session_id, [sessionInfoTemp]);
  const title = useMemo(() => realPlayRecording?.roleplay?.name, [realPlayRecording?.roleplay]);
  const isRecording = useMemo(() => selectedScenario?.isRecording, [selectedScenario?.isRecording]);
  const scenario_uuid = useMemo(() => selectedScenario?.uuid, [selectedScenario?.uuid]);
  const videoURL = useMemo(() => selectedScenario?.response?.video, [selectedScenario]);
  const status = useMemo(() => sessionInfoTemp?.status, [sessionInfoTemp]);
  const tempVideoUrl = useMemo(
    () => selectedScenario?.tempVideoUrl,
    [selectedScenario?.tempVideoUrl]
  );

  const persona_name = useMemo(() => client?.name, [client]);
  const persona_image = useMemo(() => client?.profile_pic, [client]);

  const formatDate = () => {
    const dateString = new Date();

    let month = dateString.getUTCMonth() + 1;
    if (month < 10) month = `0${month}`;
    let day = dateString.getUTCDate();
    if (day < 10) day = `0${day}`;
    let year = dateString.getUTCFullYear();

    const newDate = day + '-' + month + '-' + year;
    return newDate;
  };

  const formattedDate = () => {
    if (endDate) {
      const date = new Date(endDate);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
    return formatDate();
  };

  //functions
  const {
    setRealPlayRecording,
    setScenarioWithSelector,
    setIsRecordingScenario,
    setTempVideoUrl,
    setSessionInfoTemp,
    updateSessionStatus,
    setIsLoadingVideoTemp,
    reset,
  } = useRealplayStore();

  return {
    formattedDate,
    self_assigned,
    assigned_to_user,
    isLoadingVideoTemp,
    assignment_uuid,
    assigned_by_user,
    roleplay,
    scenarios,
    ratingCriteria,
    client,
    attitude,
    voice_id,
    customer_context,
    selectedScenario,
    sessionInfoTemp,
    endDate,
    session_uuid,
    title,
    isRecording,
    scenario_uuid,
    videoURL,
    status,
    tempVideoUrl,
    persona_name,
    persona_image,
    setRealPlayRecording,
    setScenarioWithSelector,
    setIsRecordingScenario,
    setTempVideoUrl,
    setSessionInfoTemp,
    updateSessionStatus,
    setIsLoadingVideoTemp,
    reset,
  };
};

export default RealPlayRecordDataHelper;
